import React from 'react';
import { Box, Typography } from '@mui/material';

export const SettingsDashboard: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4">Settings Dashboard</Typography>
    </Box>
  );
}; 